import {LOCATE_OPTIONS_SIGNATURE} from "../types";

const showOptionsSignature= (visible) => {
  return ({type: LOCATE_OPTIONS_SIGNATURE, payload: {visibleSignatureOptions: visible}});
};
export default showOptionsSignature;